import React from 'react'
import { useField } from 'formik'
import {
  FormControl,
  FormHelperText,
  InputLabel,
  Switch,
  makeStyles,
} from '@material-ui/core'
import equal from 'fast-deep-equal'

const useStyles = makeStyles(theme => ({
  switch: {
    backgroundColor: 'white',
    borderRadius: theme.shape.borderRadius,
    padding: '8px 12px 0px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  label: {
    width: '100%',
    position: 'static',
    transform: 'translate(-0, 2px) scale(1)',
    fontSize: '0.75rem',
  },
}))

const FormikToggle = props => {
  const [field, meta] = useField(props)
  const { touched, error } = meta
  const hasError = Boolean(touched && error)
  const { value } = field

  return <FormikToggleMemo {...{ hasError, error, field, value, ...props }} />
}

const FormikToggleMemo = React.memo(
  ({
    error,
    field,
    fullWidth,
    hasError,
    label,
    margin,
    value,
    variant,
    ...props
  }) => {
    const classes = useStyles()
    return (
      <FormControl
        error={hasError}
        fullWidth={fullWidth}
        margin={margin}
        variant={variant}
      >
        <div className={classes.switch}>
          <InputLabel shrink={false} className={classes.label}>
            {label}
          </InputLabel>
          <Switch {...field} {...props} checked={Boolean(value)} />
        </div>
        {hasError && <FormHelperText>{error}</FormHelperText>}
      </FormControl>
    )
  },
  equal
)

FormikToggle.defaultProps = {
  variant: 'filled',
}

export default FormikToggle
